"use strict";
/**
 * Shared recommendation-ranking constants (spec #525 — impact-ranked,
 * variable-count top recommendations). SINGLE SOURCE OF TRUTH for the impact
 * bar, the ceiling, and the impact→rank ordering used to select which
 * recommendations surface in a report.
 *
 * These are the cross-consumer "shared constants" the constitution's
 * "shared cross-lambda constants" rule governs: the bedrock-evaluator's
 * synthesis reads them to rank/filter/cap the recommendation list, and any
 * downstream consumer that wants to sort by impact imports the SAME
 * `IMPACT_RANK` — never a re-literalled `'medium'` bar or `5` cap per side.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFICIENCY_CODED_WORDS = exports.RECOMMENDATION_CONSOLIDATION_MIN = exports.MAX_RECOMMENDATIONS = exports.MIN_RECOMMENDATION_IMPACT = exports.IMPACT_RANK = void 0;
/**
 * Total order over impact levels — lower number = higher impact. Used both to
 * rank recommendations (sort ascending) and to compare against the bar.
 */
exports.IMPACT_RANK = {
    high: 0,
    medium: 1,
    low: 2,
};
/**
 * The impact floor: recommendations whose impact ranks strictly below this bar
 * are dropped (spec #525 AC-2.1). `'medium'` keeps `medium` + `high`, drops
 * `low`. A recommendation qualifies iff
 * `IMPACT_RANK[rec.impact] <= IMPACT_RANK[MIN_RECOMMENDATION_IMPACT]`.
 */
exports.MIN_RECOMMENDATION_IMPACT = 'medium';
/**
 * The ceiling: at most this many recommendations survive after the impact
 * filter (spec #525 AC-2.2). The final list is the top `MAX_RECOMMENDATIONS`
 * by impact (ties broken by the pre-existing dimension-order priority).
 */
exports.MAX_RECOMMENDATIONS = 5;
/**
 * The consolidation trigger (spec #540 FR-2): the Haiku consolidation pass —
 * which adds root-cause + representative examples provenance across related
 * recommendations — runs ONLY when the impact-ranked set has strictly MORE than
 * this many recommendations. At or below this count there is nothing to
 * consolidate, so the pass is skipped (no LLM call). SINGLE SOURCE OF TRUTH:
 * imported by every side that gates the consolidation pass — never re-literalled
 * per-Lambda (constitution "shared cross-lambda constants").
 */
exports.RECOMMENDATION_CONSOLIDATION_MIN = 3;
/**
 * The R5 deficiency-coded-word denylist (spec #615). SINGLE SOURCE OF TRUTH for
 * the words a recommendation `title`/`description` may NOT use — the gap must be
 * carried by the underlying metric (a percentage or count) instead of a
 * judgmental adjective.
 *
 * Both recommendation-wording prompts source this ONE list: the Delivery
 * prompt (`bedrock-evaluator`'s `buildSystemPrompt`) and the Discovery prompt.
 * This is the "shared cross-lambda constants" the constitution governs — never
 * re-literal these seven words per-mode; import THIS constant on every side.
 */
exports.DEFICIENCY_CODED_WORDS = [
    'inconsistent',
    'inconsistently',
    'lacking',
    'missing',
    'fails to',
    "doesn't",
    'poor',
];
//# sourceMappingURL=recommendations.js.map